import React, {useState} from 'react';
import {Alert, Col, FormGroup, Label, Row} from 'reactstrap';
import Printhead from './printhead';
import Vrate from './vrate';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';
import FormField from '../../components/Common/FormField';

const GtxProBulk = () => {
  const [serialStatus, setSerialStatus] = useState(true);

  function handleChangeMachineSerial(machineSerialNo) {
    if (machineSerialNo.length === 8) {
      const url = process.env.REACT_APP_APIURL + 'machine/checkduplicate';
      const authToken = authHeader();

      const formData = new FormData();
      formData.append('serial', machineSerialNo);

      return axios.post(url, formData, {headers: authToken}).then(
          (response) => {
            setSerialStatus(response.status === 201);
          }).catch(() => {
        setSerialStatus(false);
      });
    }
  }

  return (
    <React.Fragment>
      <FormGroup className="mb-4" row>
        <Label htmlFor="ink_supply_serial" md="2" className="col-form-label">Ink Supply Serial No. *</Label>
        <Col md="10">
          <FormField
            name="ink_supply_serial"
            className="form-control"
            placeholder="Ink Supply Serial No. *"
            type="text"
            validate={
              {
                required: {value: true},
                pattern: {value: /^[A-Z]{1}[0-9]{7}$/},
              }
            }
            maxLength={8}
            errorMessage="Please provide a valid serial."
            helpMessage="Example: A1234567."
          />
        </Col>
      </FormGroup>
      <FormGroup className="mb-4">
        <Label className="col-form-label">Print Head Serials</Label>
        <Alert color="danger" role="alert">
          Please note: the following print head serial numbers are the
          original print heads that are installed with the installation
        </Alert>
        <table style={{width: '100%'}}>
          <tbody>
            <tr>
              <td>
                <Row className="mb-2 px-2">
                  <Label md="2" className="col-form-label">PH Serial CMYK *</Label>
                  <Col md="4">
                    <Printhead
                      example="GXA1234"
                      name="print_heads[gtxprobulk][0][serial]"
                      placeholder="PH Serial CMYK *"
                    />
                    <FormField
                      name="print_heads[gtxprobulk][0][position]"
                      value="1"
                      type="hidden"
                    />
                    <FormField
                      name="print_heads[gtxprobulk][0][type]"
                      value="color"
                      type="hidden"
                    />
                  </Col>
                  <Label md="2" className="col-form-label">V.Rating*</Label>
                  <Col md="4">
                    <Vrate name="print_heads[gtxprobulk][0][vrate]"/>
                  </Col>
                </Row>
              </td>
            </tr>
            <tr>
              <td>
                <Row className="mb-2 px-2">
                  <Label md="2" className="col-form-label">PH Serial white *</Label>
                  <Col md="4">
                    <Printhead
                      example="XAA1234"
                      name="print_heads[gtxprobulk][1][serial]"
                      placeholder="PH Serial white *"
                    />
                    <FormField
                      name="print_heads[gtxprobulk][1][position]"
                      value="2"
                      type="hidden"
                    />
                    <FormField
                      name="print_heads[gtxprobulk][1][type]"
                      value="white"
                      type="hidden"
                    />
                  </Col>
                  <Label md="2" className="col-form-label">V.Rating
                  *</Label>
                  <Col md="4">
                    <Vrate name="print_heads[gtxprobulk][1][vrate]"/>
                  </Col>
                </Row>
              </td>
            </tr>
          </tbody>
        </table>
      </FormGroup>
      <FormGroup className="mb-4" row>
        <Label htmlFor="r2r_unit_serial" md="2" className="col-form-label">R2R-Unit Serial (optional)</Label>
        <Col md="10">
          <FormField
            name="r2r_unit_serial"
            className="form-control"
            placeholder="R2R-Unit Serial"
            type="text"
            validate={{pattern: {value: /^[0-9]{8}$/}}}
            onChange={(e) => handleChangeMachineSerial(e.target.value)}
            maxLength={8}
            errorMessage="Please provide a valid serial."
            helpMessage="Example: 001 please input as 00000001 (8 digit number)"
          />
          {!serialStatus && <Alert color="danger">This serial number already exists!</Alert>}
        </Col>
      </FormGroup>
    </React.Fragment>
  );
};

export default GtxProBulk;
